import { createContext } from 'react';
import { ONE_MINUTE, ONE_DAY } from './utils.js';

var mockFn = function () { return undefined; };
var ConfirmationContext = createContext({
    alignContent: 'left',
    texts: {},
    state: 'INITIAL',
    screen: 'INITIAL',
    requiredCharAmount: 5,
    countdownDuration: ONE_MINUTE,
    timeLeft: ONE_MINUTE,
    tempBlockDuration: ONE_DAY,
    phone: '',
    hideCountdownSection: false,
    breakpoint: 1024,
    client: 'desktop',
    initialScreenHintSlot: null,
    onTempBlockFinished: mockFn,
    onInputFinished: mockFn,
    onChangeState: mockFn,
    onSmsRetryClick: mockFn,
    onChangeScreen: mockFn,
    onFatalErrorOkButtonClick: mockFn,
});

export { ConfirmationContext };
